import httpClient from ".";
import type {
  ICareHistoryConfigPayload,
  ICareHistoryGraphPayload,
  ICareHistoryClaimsPayload,
  ICareHistoryExportPayload,
  IEOBPayload,
} from "@/types";
import { API_ENDPOINTS } from "./endpoints";

export const fetchCareHistoryConfig = async (
  configPayload: ICareHistoryConfigPayload,
) => {
  const url = API_ENDPOINTS.CARE_HISTORY.CONFIG;
  const { token, ...payload } = configPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "2.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchCareHistoryGraph = async (
  graphPayload: ICareHistoryGraphPayload,
) => {
  const url = API_ENDPOINTS.CARE_HISTORY.GRAPH;
  const { token, ...payload } = graphPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchCareHistoryClaims = async (
  claimsPayload: ICareHistoryClaimsPayload,
) => {
  const url = API_ENDPOINTS.CARE_HISTORY.CLAIMS;
  const { token, ...payload } = claimsPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchDownloadClaims = async (
  exportPayload: ICareHistoryExportPayload,
): Promise<{
  filename: string;
  success: boolean;
  base64Encoded: string;
  message: string;
}> => {
  const url = API_ENDPOINTS.CARE_HISTORY.EXPORT;
  const { token, ...payload } = exportPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};

export const fetchEOB = async (eobPayload: IEOBPayload) => {
  const url = API_ENDPOINTS.CARE_HISTORY.EOB;
  const { token, ...payload } = eobPayload;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Accept-Version": "2.0",
    },
  };
  return httpClient
    .post(url, payload, config)
    .then((response) => response.data);
};
